/**
 * Homepage selectors
 */

import { createSelector } from 'reselect';

const selectTree = (state) => state.get('tree');

const getFooObj = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('foo');
  }
);
const getNodeObjsByNode = (node) => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('nodeObjs')[node];
  }
);

const getNodeObjs = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('nodeObjs');
  }
);

const getFanChartData = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('fanChartData');
  }
);


const getFanChartUniqueChars = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('uniqueFanChartChars');
  }
);

const getHashWidthsNamesForFanchart = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('hashWidthsNamesForFanchart');
  }
);

const get_nodeobjsbyrange = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('nodeObjsByRange');
  }
);

const get_countOf = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('countOf');
  }
);

const getEdges = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('edges');
  }
);

const get_focusnode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('focusNode');
  }
);

const get_cid_grps = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('cidsGrps');
  }
);

const get_firstTreeMatchCountNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstTreeMatchCountNode');
  }
);

const get_firstDNANode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstDNANode');
  }
);

const get_firstRecordMatchCountNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstRecordMatchCountNode');
  }
);

const get_firstMaleGhostNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstMaleGhostNode');
  }
);

const get_firstFemaleGhostNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstFemaleGhostNode');
  }
);

const get_firstTreeMatchNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstTreeMatchNode');
  }
);

const get_firstDeadNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstDeadNode');
  }
);

const get_firstRecordMatchNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstRecordMatchNode');
  }
);

const get_firstSmartMatchNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstSmartMatchNode');
  }
);


const get_firstCycleMasterNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstCycleMaster');
  }
);

const get_multipleParentNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstMultipleParentNode');
  }
);

const get_firstConflictNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstConflictNode');
  }
);

const get_firstEditNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstEditNode');
  }
);

const get_firstEmailRequestNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstEmailRequestNode');
  }
);


const get_firstInconsistentencyNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstInconsistentencyNode');
  }
);


const get_firstMergePendingNode = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstMergePendingNode');
  }
);


const get_firstAppear05Node = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstAppear05Node');
  }
);


const get_firstAppear06Node = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstAppear06Node');
  }
);


const get_firstAppear07Node = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstAppear07Node');
  }
);


const get_firstAppear08Node = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstAppear08Node');
  }
);

const get_firstAppear09Node = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('firstAppear09Node');
  }
);

const get_numofgenerations = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('numOfGenerations');
  }
);


const getProfileObjs = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('profileObjs');
  }
);


const getFlipcardData = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('data').get('flipBoxData');
  }
);

const getUnions = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('data').get('unions')
);

const getlookUpPrId = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('data').get('lookUpPrId')
);

const getBranches = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('data').get('branches')
);

const getTreeLoaded = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('data').get('loaded')
);

const getFocusPrId = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('prId')
);

const getViewport = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('ui').get('viewport')
);

const getProgress = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('ui').get('progress')/*.get('loaded')*/
);

const getPreferences = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('user')
);


const getIsLargeTree = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('user').get('isLargeTree')
);


const getLegendDescriptions = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('user').get('legendDescriptions')
);

const getGuide_page = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('user').get('guide_page')
);


const getNodeCount = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('user').get('nodecount')
);


const getFloaters = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('user').get('floaters')
);

const getResolve = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('user').get('resolve')
);


const getIsPedigree = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('user').get('isPedigree')
);

const getIsFanChart = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('user').get('isFanChart')
);

const getChartType = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('user').get('chartType')
);

const getMaxAncestorGen = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('user').get('maxAncestorGen')
);

const getIsDualPedigree = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('user').get('isDualPedigree')
);

const getDualPedigreePosterId = () => createSelector(
  selectTree,
  (TreeState) => {
    const dualPedigreeObj = TreeState.get('user').get('dualPedigreeObj');
    return dualPedigreeObj.tpId;
  }
);

const getDualPedigreeFocusRoot = (node) => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('user').get('dualPedigreeFocusRoot')
  }
);

const getDualPedigreeObj = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('user').get('dualPedigreeObj');
  }
);
const getFanchartObj = () => createSelector(
  selectTree,
  (TreeState) => {
    return TreeState.get('user').get('fanchartObj');
  }
);

const getCanvasWidth = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('ui').get('canvas').get('width')
);


const getCanvasHeight = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('ui').get('canvas').get('height')
);


const getCanvasTop = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('ui').get('canvas').get('top')
);


const getShiftDownCanvasTop = () => createSelector(
  selectTree,
  (TreeState) => TreeState.get('ui').get('canvas').get('shiftDownCanvasTop')
);


export {
  getFooObj,
  getNodeObjsByNode,
  getNodeObjs,
  getFanChartData,
  getFanChartUniqueChars,
  getHashWidthsNamesForFanchart,
  getDualPedigreeObj,
  getFanchartObj,
  get_nodeobjsbyrange,
  get_countOf,
  getEdges,
  get_focusnode,
  get_cid_grps,
  get_firstTreeMatchCountNode,
  get_firstDNANode,
  get_firstTreeMatchNode,
  get_firstDeadNode,
  get_firstRecordMatchCountNode,
  get_firstRecordMatchNode,
  get_firstSmartMatchNode,
  get_firstMaleGhostNode,
  get_firstFemaleGhostNode,
  get_firstCycleMasterNode,
  get_multipleParentNode,
  get_firstConflictNode,
  get_firstEditNode,
  get_firstEmailRequestNode,
  get_firstInconsistentencyNode,
  get_firstMergePendingNode,
  get_firstAppear05Node,
  get_firstAppear06Node,
  get_firstAppear07Node,
  get_firstAppear08Node,
  get_firstAppear09Node,
  get_numofgenerations,
  // getlookUpNodeId,
  getlookUpPrId,
  getProfileObjs,
  getUnions,
  getBranches,
  getTreeLoaded,
  getFocusPrId,
  getViewport,
  getProgress,
  getCanvasWidth,
  getCanvasHeight,
  getCanvasTop,
  getShiftDownCanvasTop,
  getPreferences,
  getFloaters,
  getIsLargeTree,
  getLegendDescriptions,
  getGuide_page,
  getNodeCount,
  getResolve,
  getIsPedigree,
  getIsFanChart,
  getChartType,
  getMaxAncestorGen,
  getIsDualPedigree,
  getDualPedigreePosterId,
  getDualPedigreeFocusRoot,
  getFlipcardData,
};
